export default {
  shapeName: "chevron/up",
  change: [
    {
      rotate: 180,
    },
  ],
};
